<template>
  <div class="department-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('departments.title') }}</h2>
      <b-button variant="primary" @click="createDepartment">
        <i class="fas fa-plus mr-2"></i>{{ $t('departments.create_button') }}
      </b-button>
    </div>
    <CrudTable :columns="fields" :data-sources="departments" :pagination="paginationInfo" :loader="isLoading"
      list-url="/departments" @search="handleSearch" @filter="handleFilter" @refresh="fetchDepartments" ref="action-table">
      <template #cell(name)="data">
        <div class="font-weight-bold">{{ data.item.name || 'N/A' }}</div>
      </template>
      <template #cell(description)="data">
        <div>{{ data.item.description || 'N/A' }}</div>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <b-button variant="outline-primary" size="sm" @click="editDepartment(data.item)">
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>
    <ConfirmDeleteModal v-if="selectedDepartment" :show.sync="showDeleteModal" :item-id="selectedDepartment.id"
      delete-url="/departments" :message="$t('departments.confirm_delete_message', { department: selectedDepartment.name })"
      success-message="$t('departments.deleted_successfully')" error-message="$t('common.something_went_wrong')"
      @deleted="handleItemDeleted" />
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";

export default {
  name: "DepartmentList",
  components: {
    CrudTable,
    ConfirmDeleteModal
  },
  data() {
    return {
      departments: [],
      isLoading: false,
      showDeleteModal: false,
      selectedDepartment: null,
      currentPage: 1,
      perPage: 10,
      sortBy: "created_at",
      sortDesc: true,
      filters: {
        search: "",
      },
      fields: [
        { key: "name", label: this.$t("departments.table_header_name"), sortable: true, sortDirection: "asc" },
        { key: "description", label: this.$t("departments.table_header_description"), sortable: false },
        { key: "actions", label: this.$t("common.actions") },
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0,
      },
    };
  },
  methods: {
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchDepartments();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchDepartments();
    },
    createDepartment() {
      this.$router.push("/admin/departments/create");
    },
    editDepartment(department) {
      this.$router.push(`/admin/departments/${department.id}/edit`);
    },
    confirmDelete(department) {
      this.selectedDepartment = department;
      this.showDeleteModal = true;
    },
    handleItemDeleted() {
      this.$refs['action-table'].refreshTableData();
      this.$bvToast.toast(this.$t('departments.deleted_successfully'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
    },
    async fetchDepartments() {
      this.isLoading = true;
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
          ...this.filters,
        };

        const response = await request({
          method: "get",
          url: "/departments",
          params,
        });

        // Handle paginated response from API
        this.departments = response.data.data || [];
        this.paginationInfo = {
          from: response.data.from || 0,
          to: response.data.to || 0,
          total: response.data.total || 0,
        };
      } catch (error) {
        this.$bvToast.toast(this.$t('departments.fetch_error'), {
          title: this.$t('common.error'),
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetchDepartments();
  },
};
</script>
